/** Fixed Ask Dink panel copy (DNKADM-0434; reworked to the DNKADM-0460 design). */

/** `429 ASSISTANT_RATE_LIMITED`. */
export const RATE_LIMITED_COPY = "You've asked a lot this hour, try again soon";

/** `503 ASSISTANT_UNAVAILABLE`, and any other failed ask: the unavailable card's title. */
export const UNAVAILABLE_COPY = "Dink can't answer right now";

/** The unavailable card's body. The question goes back in the box, so this stays true. */
export const UNAVAILABLE_DETAIL_COPY =
  "Something's wrong on our end, not yours. Your question is saved, so you won't need to type it again.";

/** The footer line under the question box (spec item 6). */
export const FOOTER_COPY = 'Dink points the way. You make the changes.';

/** The loading steps (spec item 2), shown in order while an answer is on its way. */
export const LOADING_STEPS = [
  'Reading your question',
  'Checking the help guide',
  'Writing the answer',
] as const;

/**
 * When each loading step after the first starts, in seconds. The API does not stream
 * progress, so the steps are paced by the clock, not by server events.
 */
export const LOADING_STEP_STARTS = [2, 5] as const;

/** What Dink does and does not do, on the empty panel. Help-guide claims only. */
export const DINK_CAN = ['Explain how things work', 'Take you to the right screen'] as const;
export const DINK_CANT = [
  'Change bookings or members',
  'Charge, refund or add credits',
  'Message members',
] as const;

/** The history view's privacy line (spec item 4). */
export const HISTORY_PRIVACY_COPY = 'Only you can see these. They clear when you sign out.';

/** DNKADM-0462: dictation into the question box. */
export const VOICE_BUTTON_LABEL = 'Ask by voice';
export const VOICE_LISTENING_PLACEHOLDER = 'Listening...';
export const VOICE_BLOCKED_COPY = 'Microphone is blocked for this site. You can still type.';

/** DNKADM-0463: "Ask about this" (point at something on the screen). */
export const PICK_BUTTON_LABEL = 'Ask about this';
export const PICK_MODE_PLACEHOLDER = 'Click something on the page. Esc to cancel.';
export const PICK_CHIP_REMOVE_LABEL = 'Remove picked item';
